"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisposableStore = void 0;
var dispose_trace_1 = require("./dispose-trace");
var dispose_marktrack_1 = require("./dispose-marktrack");
var DisposableStore = /** @class */ (function () {
    function DisposableStore() {
        // 待销毁的子节点
        this.toDisposeSet = new Set();
        // store的销毁状态，store只能销毁一次
        this.isDisposeState = false;
    }
    /**
     * 遍历销毁当前store的子节点
     * @param trace 基于销毁的层级日志
     */
    DisposableStore.prototype.dispose = function (trace) {
        if (this.isDisposeState) {
            return;
        }
        dispose_marktrack_1.markTracked(this);
        this.isDisposeState = true;
        if (trace) {
            this.clear(trace);
        }
        else {
            var storeDisposeTrace = dispose_trace_1.DisposeTrace.traceRoot(this.constructor.name);
            this.clear(storeDisposeTrace);
            storeDisposeTrace.stop();
        }
    };
    DisposableStore.prototype.clear = function (trace) {
        this.toDisposeSet.forEach(function (item) {
            var disposableId = item.disposableId || item.constructor.name;
            item.dispose(trace === null || trace === void 0 ? void 0 : trace.branch(disposableId));
        });
        this.toDisposeSet.clear();
    };
    DisposableStore.prototype.add = function (t) {
        if (!t) {
            return t;
        }
        if (t === this) {
            throw new Error('Cannot register a disposable on itself!');
        }
        dispose_marktrack_1.markTracked(t);
        if (this.isDisposeState) {
            if (!DisposableStore.DISABLE_DISPOSED_WARNING) {
                console.warn(new Error('Trying to add a disposable to a DisposableStore that has already been disposed of. The added object will be leaked!').stack);
            }
        }
        else {
            this.toDisposeSet.add(t);
        }
        return t;
    };
    DisposableStore.DISABLE_DISPOSED_WARNING = false;
    return DisposableStore;
}());
exports.DisposableStore = DisposableStore;
//# sourceMappingURL=disposable-store.js.map